export const ONETEXT_GITHUB_ORG = "one-text";
export const ONETEXT_GITHUB_PROJECT_NUMBER = 2;
export var GITHUB_REPO_NAME = /* @__PURE__ */ ((GITHUB_REPO_NAME2) => {
  GITHUB_REPO_NAME2["ROADMAP"] = "onetext-roadmap";
  GITHUB_REPO_NAME2["API"] = "onetext-api";
  GITHUB_REPO_NAME2["SITE"] = "onetext-site";
  return GITHUB_REPO_NAME2;
})(GITHUB_REPO_NAME || {});
export var GITHUB_PROJECT_COLUMN_ID = /* @__PURE__ */ ((GITHUB_PROJECT_COLUMN_ID2) => {
  GITHUB_PROJECT_COLUMN_ID2["STAGED"] = "e5b7d971";
  GITHUB_PROJECT_COLUMN_ID2["PRIORITIZED"] = "d296c98a";
  GITHUB_PROJECT_COLUMN_ID2["IN_PROGRESS"] = "47fc9ee4";
  GITHUB_PROJECT_COLUMN_ID2["IN_REVIEW"] = "28a63266";
  GITHUB_PROJECT_COLUMN_ID2["DONE"] = "98236657";
  return GITHUB_PROJECT_COLUMN_ID2;
})(GITHUB_PROJECT_COLUMN_ID || {});
export var GITHUB_TEAM_SLUG = /* @__PURE__ */ ((GITHUB_TEAM_SLUG2) => {
  GITHUB_TEAM_SLUG2["ENGINEERING"] = "engineering";
  GITHUB_TEAM_SLUG2["PRODUCT"] = "product";
  return GITHUB_TEAM_SLUG2;
})(GITHUB_TEAM_SLUG || {});
export var GITHUB_TICKET_TYPE = /* @__PURE__ */ ((GITHUB_TICKET_TYPE2) => {
  GITHUB_TICKET_TYPE2["ISSUE"] = "issue";
  GITHUB_TICKET_TYPE2["DRAFT"] = "draft";
  return GITHUB_TICKET_TYPE2;
})(GITHUB_TICKET_TYPE || {});
export var GITHUB_PRIORITY_LABELS = /* @__PURE__ */ ((GITHUB_PRIORITY_LABELS2) => {
  GITHUB_PRIORITY_LABELS2["P0"] = "p0";
  GITHUB_PRIORITY_LABELS2["P1"] = "p1";
  GITHUB_PRIORITY_LABELS2["P2"] = "p2";
  GITHUB_PRIORITY_LABELS2["P3"] = "p3";
  return GITHUB_PRIORITY_LABELS2;
})(GITHUB_PRIORITY_LABELS || {});
export var GITHUB_ISSUE_CLASSIFICATION_LABELS = /* @__PURE__ */ ((GITHUB_ISSUE_CLASSIFICATION_LABELS2) => {
  GITHUB_ISSUE_CLASSIFICATION_LABELS2["BUG"] = "bug";
  GITHUB_ISSUE_CLASSIFICATION_LABELS2["ENHANCEMENT"] = "enhancement";
  GITHUB_ISSUE_CLASSIFICATION_LABELS2["TECH_DEBT"] = "tech-debt";
  GITHUB_ISSUE_CLASSIFICATION_LABELS2["SCALABILITY"] = "scalability";
  return GITHUB_ISSUE_CLASSIFICATION_LABELS2;
})(GITHUB_ISSUE_CLASSIFICATION_LABELS || {});
